const ar = {
  home: 'الرئيسية',
  najizPlatform: 'منصة ناجز',
  judicalEServices: 'المنصة الموحدة للخدمات العدلية الإلكترونية',
  enter: 'الدخول',
  noServicesFoundPleaseTryAgain: 'لا توجد خدمات.',
  new: 'جديد',
  modified: 'معدلة',
  redirectToService: 'الانتقال الى خدمة-',
  scrollForMore: 'مرر للمزيد',
  businessAccountActivationRequirements: 'أبرز متطلبات تفعيل حساب أعمال',
  accountValidityPeriod: 'مدة صلاحية الحساب',
  fromActivationDate: 'من تاريخ التفعيل',
  accountCreationFees: 'رسوم إنشاء الحساب',
  activateFirstOrganizationAccountText: 'تفعيل الحساب الأول للمنشاة',
  activateFirstOrganizationAccountDescription: 'وسيتم احتساب رسوم للحسابات الإضافية .',
  fees: 'برسوم',
  free: 'مجانًا',
  sar: 'ريال سعودي',
  year: 'سنة',

  verificationServices: {
    title: 'خدمات التحقق',
    description: 'تمكنك هذه الخدمة من التحقق من الوثائق الصادرة من وزارة العدل إلكترونياً',
    userNeed: 'أريد التحقق من',
    viewAllServices: 'عرض كل الخدمات',
  },

  appInsights: {
    verificationServicesArName: 'خدمات التحقق',
  },

  serviceUsage: 'استخدام الخدمة',
  mostUsed: 'الأكثر استخداماً',
  serviceExplaination: 'شرح الخدمة',

  services: {
    title: 'الخدمات الإلكترونية',
    explaination: 'شرح الخدمة',
    browseAllServices: 'عرض كل الخدمات',
    searchInServices: 'ابحث في الخدمات الإلكترونية',
    prominentServices: 'أبرز الخدمات الإلكترونية',
    browseAll: 'عرض الكل',
    categoriesLabel: 'فئات الخدمات',
  },

  licenseType: 'نوع الترخيص',
  chooseLicenseType: 'اختر نوع الترخيص',
  iWantToPreview: 'أريد استعراض دليل ',
  najizData: 'ناجز بيانات',
  last7Days: 'البيانات المعروضة لآخر 7 أيام',
  najizDataDescription: 'الحل الأمثل لطلب  البيانات الموثوقة وخلق فرص جديدة للأعمال',
  najizDataLogin: 'دخول لناجز بيانات',
  najizInNumbers: 'ناجز بالأرقام',
  email: 'البريد الإلكتروني',
  withMaxLengthChars: 'بحد أقصى {length} حرف',

  contactWithUs: {
    title: 'تواصل معنا',
    slogan: 'نحن هنا لخدمتكم ويمكنكم التواصل معنا في أي وقت',
    contactInsideKSA: 'تواصل معنا من داخل المملكة',
    fromSunToThurs: 'من الأحد إلى الخميس',
    fromInsideKSA: 'من داخل المملكة العربية السعودية',
    contactUs: 'تواصل معنا',
    contactOutsideKSA: 'اتصل بنا من خارج المملكة',
    contactTime: 'من 8 صباحاً إلى 2:15 مساءً (الأحد - الخميس)',
    fromOutsideKSA: 'من خارج المملكة العربية السعودية',
    messageUs: 'راسلنا',
    allWeekDays: 'طوال أيام الاسبوع',
    allTheTime: 'جميع الأوقات',
    instantChat: 'المحادثة الفورية',
    chatWithUs: 'تحدث معنا',
    pleaseToServeYou: 'نسعد بخدمتكم بجميع مراكز ناجز',
    najizCenterRiyadhBranch: 'مركز ناجز فرع الرياض',
    najizCenterRiyadhBranchLocation: 'طريق أنس ابن مالك، الملقا، الرياض 13524',
    location: 'الموقع',
    workingDays: 'أيام العمل',
    workingTime: 'أوقات العمل',
    from: 'من',
    until: 'حتى',
    atMorning: 'صباحاً',
    atNight: 'مساًء',
    najizCenterJeddahBranch: 'مركز ناجز فرع جدة',
    najizCenterJeddahBranchLocation: 'ساري ، حي الخالدية ،جدة 23423',
    najizCenterDammamBranch: 'مركز ناجز فرع الدمام',
    najizCenterDammamBranchLocation: 'طريق الظهران الجبيل السريع، الروضة،,الدمام',
    socialMediaAccounts: 'حسابات التواصل الاجتماعي',
    x: 'إكس',
    instagram: 'إنستقرام',
    snapchat: 'سناب شات',
    youtube: 'يوتيوب',
    facebook: 'فيسبوك',
    linkedin: 'لينكد إن',
    contactChannels: 'قنوات استقبال الاستفسارات والشكاوى',
    name: 'الاسم',
    enterTheName: 'أدخل الاسم',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'Example@email.com',
    phone: 'رقم الجوال',
    phonePlaceholder: '05xxxxx',
    messageTitle: 'عنوان الرسالة',
    messageTitlePlaceholder: 'أدخل عنوان الرسالة',
    messageCategory: 'فئة الرسالة',
    messageText: 'نص الرسالة',
    theMessage: 'الرسالة',
    send: 'إرسال',
    serviceAvailability: 'توفر الخدمة',
    contactNumber: 'رقم التواصل',
    responseTime: 'زمن الاستجابة',
    instant: 'فوري',
    serviceType: 'نوع الخدمة',
    liveChat: 'محادثة مباشرة',
    inquiriesAndComplaints: 'الاستفسارات والشكاوى',
    supportWithSignLanguage: 'الدعم بلغة الإشارة',
    tenDaysWork: '10 أيام عمل',
    twoWorkDays: 'يومين عمل',
    judicialContact: 'التواصل العدلي',
    signSupport: 'دعم الإشارة',
    question: 'سؤال',
    suggestion: 'اقتراح',
    help: 'مساعدة',
    messageSentSuccessfully: 'تم إرسال الرسالة بنجاح',
    contactSample: 'نموذج الاتصال',
  },

  validations: {
    fieldIsRequired: 'هذا الحقل مطلوب',
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    maxInputsLength: 'أقصى عدد للمدخلات هو {length}',
    numbersExactLength: ' عدد الأرقام يجب أن يكون {length}',
    startsWith: ' يجب أن يبدأ ب {listText}',
    phoneNumber: 'يجب أن يبدأ رقم الجوال ب {key} وأن يكون {length} أرقام',
    emailAddress: 'الرجاء إدخال بريد إلكتروني صحيح',
    onlyArabicAndNumbers: 'الرجاء إدخال أحرف عربية وأرقام فقط.',
    onlyArabicOrNumbers: 'الرجاء إدخال أحرف عربية أو أرقام فقط.',
    specialCharacters: 'الرجاء عدم إدخال رموز خاصة.',
    twitterId: 'يجب أن يكون المعرف كالآتي http(s)://twitter.com/xyz123',
    facebookId: 'يجب أن يكون المعرف كالآتي http(s)://facebook.com/xyz123',
    minWordsLength: 'أقل عدد للكلمات يجب أن يكون {length}',
    theNameMustBeBinary: 'يجب أن يكون الإسم ثنائياً',
    onlyArabic: 'يجب إدخال أحرف عربية فقط',
    duplicatePhoneNumberInContactInfo: 'يجب أن لايتطابق رقم الشخص الأول مع الشخص الثاني',
    duplicatePhoneNumberInApplicantInfo: 'يجب أن لايتطابق رقم الجوال مع رقم الجوال في البيانات الشخصية',
    alphaNumeric: 'الرجاء إدخال أحرف إنجليزية وأرقام  فقط.',
    alphaNumericAndSpecialChars: 'الرجاء إدخال أحرف إنجليزية وأرقام ورموز خاصة مثل {chars}',
  },

  faqs: {
    title: 'الأسئلة المتكررة',
    commonQuestions: 'الأسئلة الشائعة',
    searchPlaceholder: 'ابحث هنا، مثلاً: كيفية إنشاء صحيفة دعوى',
    howCanWeHelpYou: 'كيف يمكننا مساعدتك؟',
    browseAllQuestions: 'عرض كل الأسئلة',
    noQuestionsAvailable: 'لا توجد أسئلة.',
    shareQuestion: 'مشاركة السؤال',
    questionLinkCopiedSuccessfully: 'تم نسخ رابط السؤال بنجاح',
    questionDetails: 'تفاصيل السؤال',
    questionDetailsNotAvailable: 'بيانات السؤال غير متاحة',
    hintText: 'اعثر على إجابات للأسئلة الشائعة حول منتجاتنا، خدماتنا، وسياساتنا.',
    filterByCategory: 'تصفية بواسطة الفئة',
  },

  najizPartners: 'شركاء ناجز',

  contactUs: {
    title: 'تواصل معنا',
    forMoreContacts: 'لمزيد من قنوات التواصل',
  },
  mobileApplication: {
    title: 'تطبيق ناجز',
    downloadAvailability: 'يمكنكم تحميل تطبيق ناجز',
    devicesText: 'للأجهزة الذكية التي تعمل بنظامي أندرويد وأيفون',
  },

  useTheService: 'الانتقال إلى الخدمة',
  startTheService: 'بدء الخدمة',
  serviceDescription: 'وصف الخدمة',
  serviceRequirements: 'متطلبات الخدمة',
  stepsToApplyForTheService: 'خطوات التقديم على الخدمة',
  submitNewRequest: 'تقديم طلب جديد',
  followUpOnPreviousRequest: 'متابعة طلب سابق',
  authenticationOfCompletedRequest: 'مصادقة طلب مكتمل',
  serviceVideoExplaination: 'فيديو شرح الخدمة',
  youShouldKnow: 'يجب أن تعرف',

  fetchingData: 'جاري تحميل البيانات ...',
  searchResult: 'نتيجة البحث',
  searchResults: 'نتائج البحث ({searchText})',
  browseService: 'تصفح الخدمة ',
  noSearchResultsFound: 'لا يوجد نتائج تطابق البيانات المدخلة',
  noSearchResultsMessage: 'الرجاء التأكد من البيانات، والمحاولة مجدداً.',

  login: 'تسجيل الدخول',
  activateBusinessAccount: 'تفعيل حساب أعمال',
  individuals: 'أفــــــــــراد',
  businesses: 'أعمـــــال',
  government: 'حكومــة',
  lawyers: 'محامين',
  individualsLoginMsg: 'تسجيل الدخول للمواطنين والمقيمين والزوار',
  businessesLoginMsg: 'تسجيل دخول لملاك وممثلي المنشآت والجهات غير الربحية',
  governmentLoginMsg: 'تسجيل الدخول لممثلي الجهات الحكومية',
  lawyersLoginMsg: 'تسجيل الدخول للمحامين المرخصين من قبل وزارة العدل',
  forMoreDetails: 'للمزيد من التفاصيل',
  requiredDocuments: 'المستندات المطلوبة',
  serviceExecutionTime: 'مدة تنفيذ الخدمة',
  instant: 'فورية',
  serviceExecutionTimeDescription: 'من {from} - إلى {to}',
  serviceProviderChannels: 'قنوات تقديم الخدمة',
  beneficiaries: 'الفئة المستهدفة',
  serviceFees: 'رسوم الخدمة ',
  commonFaqs: 'الأسئلة الشائعة',
  checkFaqs: 'الاطلاع على الأسئلة الشائعة',
  clickHere: 'اضغط هنا',
  signalSupport: 'دعم الأشارة',
  signalCustomerSupport: 'الدعم الفني للغة الاشارة',
  allServices: 'جميع الخدمات',
  downloadApp: 'تحميل التطبيق',
  usageGuide: 'دليل الأستخدام',
  downloadUsageGuide: 'تنزيل دليل الإستخدام',
  theDescription: 'الوصف',
  theRequirements: 'المتطلبات',
  theSteps: 'الخطوات',
  share: 'مشاركة',
  serviceLinkCopiedSuccessfully: 'تم نسخ رابط الخدمة بنجاح',
  loginToCreateAccount: 'تسجيل دخول لتفعيل الحساب',

  sessionsAttendence: 'حضور الجلسات',
  ePayment: 'الدفع الإلكتروني',
  executionRequestActions: 'الإجراءات على طلب التنفيذ',
  virtualCourtExecutionRequest: 'طلب تنفيذ المحكمة الافتراضية',
  nowFromApp: 'الآن من التطبيق',
  downloadAppNow: 'حمل تطبيق ناجز الآن',
  governmentalAccountActivation: 'تفعيل حساب جهة',
  businessAccountActivation: 'تفعيل حساب أعمال',
  governmentalAccountActivationRequirements: 'متطلبات تفعيل حساب لجهة حكومية',
  activateGovernmentAccount: 'تفعيل حساب لجهة حكومية',
  noFees: 'لا يوجد رسوم',

  serverErrors: {
    USER_NOT_FOUND: 'المستخدم غير موجود الرجاء المحاولة مرة أخرى',
    INVALID_DATA: 'حدث خطأ الرجاء المحاولة مرة أخرى',
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
  },

  najizCenter: {
    about: {
      title: 'عن مركز ناجز',
      description: 'مركز عدلي نموذجي ضمن برنامج التحول الوطني، يهدف إلى تحسين تجربة المستفيدين وخدمة قطاع الأعمال، ويعنى بتقديم جميع خدمات وزارة العدل بسهولة وموثوقية عبر أربعة مسارات رئيسية: ',
      categories: 'القضاء، التنفيذ، التوثيق، المصالحة.',
      vision: {
        title: 'الرؤية',
        content: 'أن نكون النموذج الرائد في تقديم خدمات عدلية متطورة وشاملة تلبي تطلعات المستفيدين.',
      },
      mission: {
        title: 'الرسالة',
        content: 'تقديم رحلة مستفيد استثنائية من خلال تجربة عدلية، بجودة عالية وفي أوقات عمل مرنة تحقق رضا المستفيدين من الأفراد وقطاع الأعمال.',
      },
      objectives: {
        title: 'الأهداف',
        items: {
          item1: 'ضمان جودة الخدمات .',
          item2: 'توفير الوقت والجهد .',
          item3: 'تعزيز رضا المستفيدين .',
        },
      },
    },
    services: {
      title: 'الخدمات',
      description: 'يقدّم مركز ناجز جميع الخدمات العدلية نيابةً عن المستفيد، من خلال إنجاز المعاملات إلكترونيًا لضمان السرعة والدقة، وتوفير الوقت والجهد، وتشمل هذه الخدمات ما يلي:',
    },
    stats: {
      title: 'مركز ناجز في أرقام',
      figures: {
        beneficiaries: {
          value: 'مليون',
          label: 'مستفيدين',
        },
        serviceTime: {
          value: 'دقيقة',
          label: 'متوسط مدة تقديم الخدمة',
        },
        satisfaction: {
          label: 'نسبة رضا المستفيدين',
        },
      },
    },
    branches: {
      title: 'فروع مركز ناجز',
      description: 'يمتلك مركز ناجز شبكة من الفروع تغطي مختلف مناطق المملكة لتسهيل وصول المستفيدين إلى الخدمات العدلية.',
      locations: {
        workingHours: 'أوقات العمل: من الأحد إلى الخميس،',
        name: 'مركز ناجز',
        mapLink: 'عرض الموقع على الخريطة',
        morning: 'صباحًا',
        evening: 'مساءً',
      },
    },
    fixedSidebar: {
      onThisPage: 'في هذه الصفحة',
      najizCenter: 'مركز ناجز',
      about: 'عن مركز ناجز',
      services: 'الخدمات',
      judiciary: 'القضاء',
      enforcement: 'التنفيذ',
      documentation: 'التوثيق',
      reconciliation: 'المصالحة',
      stats: 'مركز ناجز في أرقام',
      branches: 'فروع مركز ناجز',
    },
  },

  // Accessibility
  skipToMainContent: 'الانتقال إلى المحتوى الرئيسي',
  nationalDayLogo: 'شعار اليوم الوطني',
  najizAppLogo: 'شعار تطبيق ناجز',
  downloadFromAppStore: 'تحميل من متجر آبل',
  downloadFromGooglePlay: 'تحميل من متجر جوجل بلاي',
  loginTo: 'تسجيل الدخول إلى',
  visitPartner: 'زيارة موقع',

};

export default ar;
